<template>
  <div class="step__block-row">
    <p class="step__block-text">Delivery weight, pound</p>
    <p class="step__block-text">{{ totalWeight.toFixed() }}</p>
  </div>
  <div class="step__block-row">
    <p class="step__block-text">Numbers of delivery trucks</p>
    <p class="step__block-text">{{ numberOfTracks }}</p>
  </div>

  <div class="step__block-table">
    <div class="step__block-item step__block-item--head">
      <div></div>
      <div class="step__block-text">
        <span>Price per 1 mile</span>
      </div>
      <div class="step__block-text">
        <span>Miles</span>
      </div>
      <div class="step__block-text right">
        <span>Price SUM</span>
      </div>
    </div>
    <div
      class="step__block-item"
      v-for="item in activeDeliveryItems"
      :key="`installation-item-${item.id}`"
    >
      <div class="step__block-text left">
        <span>{{ item?.title }}</span>
      </div>
      <div class="step__block-text">
        <PriceValue :price="item.price" class="step__block-text" />
      </div>
      <div class="step__block-text">
        <span>{{ item?.qty }}</span>
      </div>
      <div class="step__block-text right">
        <PriceValue :price="item.sum" class="step__block-text right" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, watch } from "vue";
import { PriceValue } from "@/shared";

import { useDeliveryStore } from "@/stores/new/delivery.store";
import { DeliveryService } from "@/app/services/delivery.service";
import { useNewEstimateStore } from "@/stores/new/estimateStore";

const estimateStore = useNewEstimateStore();
const deliveryStore = useDeliveryStore();

const estimate = computed(() => estimateStore.estimate);
const activeDeliveryItems = computed(() => deliveryStore.deliveryItems || []);
const totalWeight = computed(() => deliveryStore.totalWeight);
const numberOfTracks = computed(() => deliveryStore.numberOfTracks);

watch(
  () => deliveryStore.totalWeight,
  (weight) => {
    const totalTracks = DeliveryService.calculateTracksNumber(weight);
    deliveryStore.numberOfTracks = totalTracks;
  },
  { deep: true },
);
</script>

<style scoped>
.step__block-text {
  font-family: Gilroy;
  font-weight: 400;
  font-size: 13px;
  line-height: 100%;
  color: rgba(5, 33, 65, 1);
}

.step__block-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.step__block-table {
  display: flex;
  flex-direction: column;
  row-gap: 10px;

  margin-block: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #d2d8e3;
}

.step__block-item {
  display: grid;
  grid-template-columns: 60% repeat(3, 1fr);
  align-items: center;
}
.step__block-item .step__block-text {
  text-align: center;
}
.step__block-item .step__block-text.left {
  text-align: left;
}
.step__block-item .step__block-text.right {
  text-align: right;
}
</style>
